module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGMAAABjCAMAAAC45U6nAAAAP1BMVEUAsj7MCif0sRm6ySD90RXOESYUtTrMCScQtDv/6BQAsj70sRm6ySD80RYTtTrOESbMCCf/6BT/1RG6ySD0sRnalKnaAAAADXRSTlP8+PX08fHx7vHx7ujn0u6ULwAAAGNJREFUeNrt2scRgCAAAEGMmMXQf612AL4cH3sNbAMX+kzDtLTlxjnGLlfYcoXrXIsdd0p7roLRvDHqisFgMBgMBoPBYDAYDAaDwWAwGAwGg8FgMBgMBoPBYDD+ZXzxX33xkT3duABHK9/CjgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/uis/assets/images/flags/mali.png
// module id = 629
// module chunks = 0